module.exports = __webpack_public_path__ + "img/icon-series-folder.53b4a96d.svg";